module.exports = "https://s3-ap-southeast-2.amazonaws.com/slik-fonts/ufc0001/img/champion-c-2.34608d13.svg";